export const UPDATE_RESTAURANT_INFO_REQUEST = 'UPDATE_RESTAURANT_INFO_REQUEST';
export const UPDATE_RESTAURANT_INFO_SUCCESS = 'UPDATE_RESTAURANT_INFO_SUCCESS';
export const UPDATE_RESTAURANT_INFO_ERROR = 'UPDATE_RESTAURANT_INFO_ERROR';

export const SCRAPE_RESTAURANT_INFO_REQUEST = 'SCRAPE_RESTAURANT_INFO_REQUEST';
export const SCRAPE_RESTAURANT_INFO_SUCCESS = 'SCRAPE_RESTAURANT_INFO_SUCCESS';
export const SCRAPE_RESTAURANT_INFO_ERROR = 'SCRAPE_RESTAURANT_INFO_ERROR';